<form [formGroup]="form" (submit)="submit()">
  <mat-card>
    <mat-card-title>{{ name }}</mat-card-title>
    <mat-card-content>
      <ul class="list-unstyled">
        <li  *ngFor="let categoryForm of form.controls; let i = index" [formGroup]="categoryForm">
            <mat-form-field validationInput *ngFor="let field of fields">
              <mat-icon matPrefix *ngIf="field.icon">{{ field.icon}}</mat-icon>
              <input matInput [formControlName]="field.name" placeholder="{{ field.title }}" type="{{ field.type ? field.type : 'text'}}" />
            </mat-form-field>
            <button mat-mini-fab type="button" (click)="removeCategory(i)">
              <mat-icon>delete</mat-icon>
            </button>
        </li>
      </ul>
      <button mat-button type="button" (click)="addCategory()">
        <mat-icon>add</mat-icon>
        Kategorie hinzufügen
      </button>
    </mat-card-content>
    <mat-card-actions>
      <button type="submit" mat-raised-button>
        Speichern
      </button>
    </mat-card-actions>
  </mat-card>
</form>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/settings/category/category.component.html